import { Waypoints } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const Footer = ({ settings }) => {
  const social = settings?.socialLinks || {};
  const atlas = settings?.atlasUrl || "https://atlas-knowledge-gps.pplx.app/";
  return (
    <footer className="relative border-t border-white/10 bg-[#05060A] py-16" data-testid="footer">
      <div className="section-shell grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="h-1.5 w-1.5 rounded-full bg-plasma-teal shadow-[0_0_12px_#1DE9B6]" />
            <span className="font-display text-xl text-white">Resonant Spark Project</span>
          </div>
          <p className="mt-4 max-w-sm font-sans text-sm font-light text-slate-500">
            A scholarly, cinematic hub for consciousness, resonance, and ancient technology —
            the living archive of Austin Cundall's inquiry.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-4">Explore</p>
          <ul className="space-y-3 font-sans text-sm text-slate-400">
            {["research", "topics", "writings", "about", "contact"].map((id) => (
              <li key={id}>
                <button onClick={() => scrollToId(id)} className="capitalize transition-colors hover:text-plasma-teal" data-testid={`footer-${id}`}>
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-4">Connect</p>
          <ul className="space-y-3 font-sans text-sm text-slate-400">
            <li><a href={social.substack} target="_blank" rel="noreferrer" className="transition-colors hover:text-plasma-teal" data-testid="footer-substack">Substack</a></li>
            <li><a href={social.x} target="_blank" rel="noreferrer" className="transition-colors hover:text-plasma-teal" data-testid="footer-x">X (Twitter)</a></li>
            <li><a href={social.academia} target="_blank" rel="noreferrer" className="transition-colors hover:text-plasma-teal" data-testid="footer-academia">Academia</a></li>
            <li><a href={`mailto:${settings?.contactEmail}`} className="transition-colors hover:text-plasma-teal" data-testid="footer-email">{settings?.contactEmail}</a></li>
            <li>
              <a href={atlas} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-gold transition-colors hover:text-white" data-testid="footer-atlas">
                <Waypoints className="h-3.5 w-3.5" strokeWidth={1.5} /> Atlas — Knowledge Map
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="section-shell mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-8 md:flex-row md:items-center">
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">
          © {new Date().getFullYear()} Resonant Spark Project · resonantsparkproject.com
        </p>
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">
          Rigor without reduction
        </p>
      </div>
    </footer>
  );
};
